import ContentLabel from "./ContentLabel";
export default ContentLabel;